import { css } from "@emotion/react"
import axios from "axios"
import { API_BASE_URL, PHOTO_DISPLAY_PATH, PHOTO_RESOURCE_BASE_URL } from "config"
import { useDisplayedPhoto } from "globalState"
import { ReactElement, useEffect, useState, MouseEvent } from "react"
import { useNavigate } from "react-router-dom"
import { BREAK_POINT_PHONE_TAB } from "style"
import { Photo } from "type"

type Props = {
}
export const RandomPhoto = (props: Props) => {
  const [random, setRandom] = useState<Photo | null>(null)
  const [, setDisplayedPhoto] = useDisplayedPhoto()
  const navigate = useNavigate()

  useEffect(() => {
    axios.get<Photo[]>(API_BASE_URL + '/image/random').then(
      (res) => {
        if (res.data.length === 0) {
          setRandom(() => null)
        } else {
          setRandom(() => res.data[0])
        }
      }
    )
  }, [])

  const onClick = (e: MouseEvent<HTMLDivElement>) => {
    if (!random) return
    const photoWithIndex = {
      ...random,
      index: 0
    }
    setDisplayedPhoto(photoWithIndex)
    navigate(PHOTO_DISPLAY_PATH, { state: { isSwipe: false, photos: [photoWithIndex] } })
  }

  let element: ReactElement | null = null
  let age: Age | null = null
  if (random === null) {
    element = null
  }
  else if (random.type === 'video') {
    element =
      <video
        autoPlay={true}
        crossOrigin="anonymous"
        css={videoCss}
        playsInline
        muted
        loop
        preload="none"
      >
        <source src={PHOTO_RESOURCE_BASE_URL + '/' + random.filename} type="video/mp4" />
      </video>

    age = calcAge(random.timestamp)
  } else {
    element =
      <img
        loading="lazy"
        src={PHOTO_RESOURCE_BASE_URL + '/' + random.filename}
        css={imgCss}
        alt="random"
      />
    age = calcAge(random.timestamp)
  }

  return (
    random === null ? <></> :
      <div css={containerCss} onClick={onClick}>
        {
          (element !== null && age !== null &&
            <>
              <div css={textCss}>{age.years}歳{age.months}ヶ月</div>
              {element}
            </>
          )
        }
      </div>
  )
}

type Age = {
  years: number,
  months: number
}

const calcAge = (millitime: number): Age => {
  const targetDate = new Date(millitime)
  const birthDay = new Date(2023, 2, 14)

  let years = targetDate.getFullYear() - birthDay.getFullYear()
  let months = targetDate.getMonth() - birthDay.getMonth()

  if (months < 0) {
    years--
    months += 12
  }

  return {
    years: years,
    months: months
  }
}

const containerCss = css`
  margin-bottom: 3px;
  position: relative;
  height: 20rem;
`

const textCss = css`
  position: absolute;
  left: 1rem;
  top: 1rem;
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
`

const videoCss = css`
  width: 100%;
  height: 100%;
  @media screen and (min-width: ${BREAK_POINT_PHONE_TAB}px){
    max-height: 700px;
  }
  object-fit: cover;
  display: block;
  margin: 0;
`

const imgCss = css`
  object-fit: cover;
  width: 100%;
  height: 100%
`